import * as ko from "knockout";
import * as mapping from "knockout.mapping";

export class NewNewspaperRequestModel {
    IsNewRequest: any;
    IsFullAddressChange: any;

    Id: any;
    SubscriptionId: any;

    AddressId: any;
    NewAddressId: any;
    OldAddressId: any;

    AddressName: any;
    NewAddressName: any;
    OldAddressName: any;

    RecipientName: any;
    NewRecipientName: any;
    OldRecipientName: any;

    NewspaperId: any;
    NewspaperName: any;
    OrderTypeId: any;

    OriginalQuantity: any;
    ModifiedQuantity: any;
    ActualQuantity: any;

    FramePrice: any;

    IsValidItem: any;

    constructor(json?: any) {
        this.IsNewRequest = ko.observable<boolean>();
        this.IsFullAddressChange = ko.observable<boolean>();

        this.Id = ko.observable<number>();
        this.SubscriptionId = ko.observable<number>();

        this.AddressId = ko.observable<number>();
        this.NewAddressId = ko.observable<number>();
        this.OldAddressId = ko.observable<number>();

        this.AddressName = ko.observable<string>();
        this.NewAddressName = ko.observable<string>();
        this.OldAddressName = ko.observable<string>();

        this.RecipientName = ko.observable<string>();
        this.NewRecipientName = ko.observable<string>();
        this.OldRecipientName = ko.observable<string>();

        this.NewspaperId = ko.observable<number>();
        this.NewspaperName = ko.observable<string>();
        this.OrderTypeId = ko.observable<number>();

        this.OriginalQuantity = ko.observable<number>();
        this.ModifiedQuantity = ko.observable<number>();
        this.ActualQuantity = ko.observable<number>();

        this.FramePrice = ko.observable<number>();

        this.AddressId.extend({
            required: true
        });
        this.NewAddressId.extend({
            required: true
        });
        this.OldAddressId.extend({
            required: true
        });

        this.RecipientName.extend({
            required: true
        });
        this.NewRecipientName.extend({
            required: true
        });
        this.OldRecipientName.extend({
            required: true
        });

        this.NewspaperId.extend({
            required: true
        });

        this.OrderTypeId.extend({
            required: true
        });

        this.ModifiedQuantity.extend({
            required: true,
            min: 1
        });
        

        this.IsValidItem = ko.pureComputed(() => {
            return (this.AddressId.isValid()
                    && this.RecipientName.isValid()
                    && this.NewspaperId.isValid()
                    && this.OrderTypeId.isValid()
                    && this.ModifiedQuantity.isValid()
                    && this.IsNewRequest()
                   )
                    ||
                   (this.NewAddressId.isValid()
                    && this.OldAddressId.isValid()
                    && !this.IsNewRequest()
                    && this.IsFullAddressChange()
                   )
                    ||
                   (this.NewAddressId.isValid()
                    && this.OldAddressId.isValid()
                    && this.NewRecipientName.isValid()
                    && this.OldRecipientName.isValid()
                    && this.NewspaperId.isValid()
                    && this.ModifiedQuantity.isValid()
                    && !this.IsNewRequest()
                    && !this.IsFullAddressChange()
                )
            ;
        });

        if (json) {
            mapping.fromJS(json, {}, this);
        }
    }
}